<template>
  <v-card 
    class="debtCard" 
    :class="{'debtNewButton primary':!debt.id, 'dense':dense,'primary':selected,'noClick':noClick}" 
    :flat="!debt.id" 
    @click="$emit('on-click')"
    :ripple="(noClick ? false : true)"
  >
    <v-card-text class="debtCardText" v-if="debt.id">
      <div class="cardIcon">
        <v-icon v-if="selected" class="white--text">mdi-check</v-icon>
        <span v-else>
          <v-icon v-if="debt.type == 'mortgage'">mdi-home</v-icon>
          <v-icon v-if="debt.type == 'credit'">mdi-credit-card</v-icon>
          <v-icon v-if="debt.type == 'auto'">mdi-car</v-icon>
          <v-icon v-if="debt.type == 'other'">mdi-bank</v-icon>
        </span>
      </div>
      
      <div class="subtitle-2" :class="{'mb-2':!dense,'white--text':selected}"><span>{{ debt.name }}</span></div>
      <div class="display-1" :class="{'white--text':selected}">{{ balanceAsOf | currencyRounded }}<span class="caption grey--text ml-2" v-if="!dense">{{ debt.interest_rate }}% APR</span></div>
      <div class="cardDelete" v-if="!hideDelete">
        <v-btn x-small text color="error" v-on:mousedown.stop="$emit('on-delete')">{{ deleteText }}</v-btn>
      </div>
    </v-card-text>
    <v-icon v-else class="white--text">mdi-plus</v-icon>
  </v-card>
    

  <!--
    <v-row class="flex-column">
      <v-col
        v-for="debt in household.debts"
        :key="'debt' + debt.id"
        class="py-1"
      >
        <v-card color="grey lighten-3 elevation-0">
          <v-card-text class="py-1">
            <v-row class="align-center">
              <v-col class="flex-grow-0 flex-shrink-1">
                <v-tooltip v-if="debt.type == 'mortgage'" top>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-home</v-icon>
                  </template>
                  <span>Mortgage</span>
                </v-tooltip>
                <v-tooltip v-if="debt.type == 'credit'" top>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-credit-card</v-icon>
                  </template>
                  <span>Credit Card</span>
                </v-tooltip>
                <v-tooltip v-if="debt.type == 'auto'" top>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-car</v-icon>
                  </template>
                  <span>Auto Loan</span>
                </v-tooltip>
                <v-tooltip v-if="debt.type == 'other'" top>
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-bank</v-icon>
                  </template>
                  <span>Other Loan</span>
                </v-tooltip>
              </v-col>
              <v-col class="debtName py-0">
                <div class="overline grey--text">Name</div>
                <div>{{ debt.name }}</div>
              </v-col>
              <v-col class="py-0">
                <div class="overline grey--text">Balance</div>
                <div>{{ debt.balance | currencyRounded }}</div>
              </v-col>
              <v-col class="py-0">
                <div class="overline grey--text">Interest Rate</div>
                <div>{{ debt.interest_rate }}%</div>
              </v-col>
              <v-col class="py-0">
                <div class="overline grey--text">Minimum Payment</div>
                <div>{{ debt.minimum_payment | currencyRounded }}</div>
              </v-col>
              <v-col class="py-0">
                <div class="overline grey--text">Payoff</div>
                <div>{{ $moment(debt.end_date).format('L') }}</div>
              </v-col>
              <v-col class="flex-grow-0 flex-shrink-1 py-0 pr-0">
                <v-btn icon @click="$router.replace({params:{debt_action: 'edit', debt_id: debt.id}})"><v-icon>mdi-pencil</v-icon></v-btn>
              </v-col>
              <v-col class="flex-grow-0 flex-shrink-1 py-0 pl-0">
                <v-btn icon @click="deleteDebt(debt)"><v-icon>mdi-delete</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>-->
</template>

<script>

export default {
  name: 'HouseholdsDebtsCard',
  props: {
    debt: {
      type: Object,
      required: true
    },
    hideDelete: Boolean,
    dense: Boolean,
    selected: Boolean,
    asOf: String,
    deleteText: {
      type: String,
      default: 'Delete'
    },
    noClick: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    balanceAsOf() {
      if(!this.asOf) return parseInt(this.debt.balance)
      if(this.asOf < this.$moment(this.debt.balance_as_of).format('YYYY-MM')) return parseInt(this.debt.balance)
      if(!this.debt.amortizationSchedule) return 0
      if(!this.debt.amortizationSchedule[ this.asOf ]) return 0
      return this.debt.amortizationSchedule[ this.asOf ].start_balance
    }
  },
  methods: {
    test() {}
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_mixins.scss';

  .debtCard {
    height: 100px;
    transition-property: background-color,box-shadow,transform,opacity;
    transition-duration: .2s;
    transition-timing-function: ease-in-out;
    cursor: default;

    ::v-deep .cardDelete {
      transition: opacity .4s ease-in-out;
      opacity: 0;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }

    &:hover {
      &:not(.noClick) {
        cursor: pointer;
        box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12);
        transform: scale(1.02);
      }

      ::v-deep .cardDelete {
        opacity: 1;
      }
    }
    &.primary:not(.debtNewButton) {
      transform: scale(1.06);
    }
  }
  .debtCardText {
    height: 100%;
  }
  .cardIcon {
    position: absolute;
    top: 5px;
    right: 5px;
    pointer-events: none;
    ::v-deep i {
      font-size: 60px !important;
      opacity: .2;
    }
    ::v-deep i.white--text {
      opacity: 1;
    }
  }
  .debtNewButton {
    &:hover {
      opacity: .8;
      box-shadow: none;
    }
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    ::v-deep i {
      font-size: 40px !important;
    }
  }
  
  .debtCard.dense {
    height: 50px;
    ::v-deep div {
      display: flex;
      flex-basis: 1;
    }
    ::v-deep .cardIcon {
      position: relative;
      top: unset;
      right: unset;
      i {
        font-size: 22px !important;
      }
    }
    ::v-deep .display-1 {
      font-size: 16px !important;
      line-height: unset;
      text-align: right;
      justify-content: flex-end;
      width: 80px;
      min-width: 80px;
      max-width: 80px;
      padding: 0px !important;
    }
    ::v-deep .subtitle-2 {
      flex: 1;
      margin-left: 4px;
      min-width: 0px;
      flex-grow: 1;
      span {
        white-space: nowrap;
        overflow: hidden;
        line-height: unset;
        text-overflow: ellipsis;
      }
    }
  }
</style>